/*LIBRARY*/
import { connect } from "react-redux";

/*DATA*/

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import useLanguage from "../common_hooks/useLanguage";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

const SET_RANGE = ({
  //variable
  properties,

  //function
  set_value_properties,
}) => {
  //localStorage
  const { language, dict } = useLanguage();

  //state & ref

  //global props
  const { field_editable } = properties;
  const { min, max, step } = field_editable;

  //variables

  //functions
  const on_change = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        [name]: value,
      },
    });
  };

  return (
    <main>
      <h1 className="text_bold margin_bottom">Pengaturan Slider</h1>

      <div>
        <p className="text_bold">{dict["Minimum value"][language]}</p>
        <input
          type="number"
          name="min"
          id="min"
          placeholder={dict["Minimum value"][language]}
          value={min}
          onChange={on_change}
          data-mapid="inputMinimum"
        />
        <p className="text_bold">{dict["Maximum value"][language]}</p>
        <input
          type="number"
          name="max"
          id="max"
          placeholder={dict["Maximum value"][language]}
          value={max}
          onChange={on_change}
          data-mapid="inputMaximum"
        />
        <p className="text_bold">{dict["Step value"][language]}</p>
        <input
          type="number"
          name="step"
          id="step"
          placeholder={dict["Step value"][language]}
          value={step}
          onChange={on_change}
          data-mapid="inputStep"
        />
      </div>

    </main>
  );
};

const mapStateToProps = (state) => ({
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_RANGE);
